export default __webpack_public_path__ + "static/media/eng_3.52509328.webp";